import React from 'react';
import styled from 'styled-components';

export default styled(({ showError, ...rest }) => <div {...rest} />)`
  position: relative;
  input {
    padding-right: 40px;
    text-overflow: ellipsis;
    border-color: ${({ showError }) => (showError ? '#d9534f' : 'rgba(0, 0, 0, 0.15)')};

    &:focus {
      border-color: ${({ showError }) => (showError ? '#d9534f' : 'rgba(0, 0, 0, 0.15)')};
    }
  }
`;
